// client/src/lib/http.ts
import axios from 'axios';
import { API_BASE } from './env';
import { getCSRFToken } from './csrf';
import { getErrorMessage } from '../utils/errors';

export const http = axios.create({
  baseURL: API_BASE,           // e.g. https://firestone-cad.com/api
  withCredentials: true,       // Enable sending cookies with requests
  headers: { Accept: 'application/json' },
  timeout: 20000,
});

// Add CSRF token and Authorization header interceptor
// CSRF token is required when CROSS_ORIGIN=true on server
http.interceptors.request.use(
  (config) => {
    // Add CSRF token from cookie if available (for cross-origin mode)
    const csrfToken = getCSRFToken();
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken;
    }
    
    // Add Authorization header with JWT token if available (for backwards compatibility)
    const token = localStorage.getItem('cad_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (err) => Promise.reject(err)
);

// If the server ever responds with HTML, treat as misroute/misconfig
http.interceptors.response.use(
  (res) => {
    const ct = (res.headers?.['content-type'] || '').toLowerCase();
    if (ct.includes('text/html')) {
      const err = new Error(
        `HTML received from API. Check API_BASE (${API_BASE}) and Nginx routing.`
      ) as any;
      err.response = res;
      throw err;
    }
    return res;
  },
  (err) => {
    // Always normalize a friendly message here so UI code can use err.userMessage
    // This prevents React errors when trying to render error objects
    if (err) {
      err.userMessage = getErrorMessage(err);
    }
    return Promise.reject(err);
  }
);

export default http;